import { render, staticRenderFns } from "./ViewOrganizationUserPayments.vue?vue&type=template&id=3d88148e&scoped=true"
import script from "./ViewOrganizationUserPayments.vue?vue&type=script&lang=js"
export * from "./ViewOrganizationUserPayments.vue?vue&type=script&lang=js"
import style0 from "./ViewOrganizationUserPayments.vue?vue&type=style&index=0&id=3d88148e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d88148e",
  null
  
)

export default component.exports